/* @flow */
import { PRODUCT_ENABLE, PRODUCT_DISABLE } from '../../../ActionsConst';

export const productDisable = (id: string) => ({
  type: PRODUCT_DISABLE,
  id,
});

export const productEnable = (id: string) => ({
  type: PRODUCT_ENABLE,
  id,
});
